import React, { useState, useEffect } from 'react';
import { useApp } from '../context/AppContext';
import { Button } from './ui/button';
import { X } from 'lucide-react';

const translations = {
  ro: {
    title: 'Acest site foloseste cookie-uri',
    message: 'Folosim cookie-uri pentru a va oferi o experienta mai buna pe site-ul nostru. Prin continuarea navigarii, sunteti de acord cu utilizarea cookie-urilor conform Politicii noastre de Confidentialitate.',
    accept: 'Accept',
    decline: 'Refuz',
    learnMore: 'Afla mai mult'
  },
  en: {
    title: 'This website uses cookies',
    message: 'We use cookies to provide you with a better experience on our website. By continuing to browse, you agree to the use of cookies according to our Privacy Policy.',
    accept: 'Accept',
    decline: 'Decline',
    learnMore: 'Learn more'
  }
};

export const CookieConsent = () => {
  const { language } = useApp();
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('rani_cookie_consent');
    if (!consent) {
      // Show after a short delay for better UX
      const timer = setTimeout(() => setShowBanner(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('rani_cookie_consent', 'accepted');
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem('rani_cookie_consent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  const t = translations[language] || translations.ro;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-white border-t shadow-2xl animate-in slide-in-from-bottom duration-500"
      data-testid="cookie-consent-banner"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex-1">
            <h4 className="font-semibold text-[#1A1625] mb-1">{t.title}</h4>
            <p className="text-sm text-muted-foreground">
              {t.message}{' '}
              <a href="/privacy" className="text-primary hover:underline">
                {t.learnMore}
              </a>
            </p>
          </div>
          <div className="flex items-center gap-3 flex-shrink-0">
            <Button
              variant="outline"
              size="sm"
              onClick={handleDecline}
              className="text-muted-foreground"
            >
              {t.decline}
            </Button>
            <Button
              size="sm"
              onClick={handleAccept}
              className="bg-primary hover:bg-purple-600"
            >
              {t.accept}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
